import React, { ChangeEvent, useRef, useState } from 'react';
import ImageIcon from 'mdi-react/ImageIcon';
import ImageEditIcon from 'mdi-react/ImageEditIcon';
import { useFormikContext } from 'formik';
import { get } from 'lodash';
import classNames from 'classnames';
import YesNoModal from 'modules/shared/YesNoModal';
import TitleUndescore from '../../../shared/TitleUndescore';
import { Input } from '../../../shared/Forms';
import Checkbox from '../../../shared/Forms/Checkbox';
import styles from './TvPanel.module.scss';
import Picker from '../../../director/containers/DirectorSettings/Picker';
import CarouselTv from '../../components/cards/PhotoCarousel/CarouselTv';
import ModalWrapper from '../../../shared/ModalWrapper';
import TopBorderBtn from '../../../shared/TopBorderBtn';
import { useModal } from '../../../shared/hooks';

type Props = {
  onChange: (e: React.ChangeEvent<any>) => void;
  values: any;
};

const TvPanel = ({ onChange, values }: Props) => {
  const canvasRef = useRef();
  const formik = useFormikContext();
  const { setFieldValue } = formik;

  const [currentImage, setCurrentImage] = useState<number>(0);

  const { isShow: isShowZoom, openModal: openZoom, closeModal: closeZoom } = useModal();
  const { isShow: isShowZoomLogo, openModal: openZoomLogo, closeModal: closeZoomLogo } = useModal();
  const { isShow: isShowDeleteCustom, openModal: openDeleteCustom, closeModal: closeDeleteCustom } = useModal();
  const { isShow: isShowDeleteLogo, openModal: openDeleteLogo, closeModal: closeDeleteLogo } = useModal();

  const customImages: any[] = get(values, 'screenRenderSettings.customScreens', []);

  const deleteCustomHandler = () => {
    closeZoom();
    closeDeleteCustom();
    setFieldValue(
      'screenRenderSettings.customScreens',
      customImages.filter((_item, idx) => idx !== currentImage),
    );
    setCurrentImage(0);
  };
  const deleteLogoHandler = () => {
    closeZoomLogo();
    closeDeleteLogo();
    setFieldValue('screenRenderSettings.imageFile', null);
    setFieldValue('screenRenderSettings.imageUrl', null);
  };

  const filesHandler = (type: 'logo' | 'custom') => (event: ChangeEvent<HTMLInputElement>) => {
    const isLogo = type === 'logo';
    const fieldName = isLogo ? 'screenRenderSettings.imageFile' : 'screenRenderSettings.customScreens';
    const logoUrlField = 'screenRenderSettings.imageUrl';
    if (isLogo) {
      // @ts-ignore
      setFieldValue(fieldName, event.currentTarget.files[0]);
      setFieldValue(logoUrlField, null);
    } else {
      // @ts-ignore
      const files = [...event.currentTarget.files];
      const arr: any = files.map((file: any) => ({ imageFile: file, id: 0 }));
      // @ts-ignore
      setFieldValue(fieldName, [...customImages, ...arr]);
    }
  };

  return (
    <div className="my-5">
      <TitleUndescore title="Відеопанель" />
      <div className="pl-4">
        <Input
          onChange={onChange}
          label="Частота перемикання екрана, сек"
          className="customSelect mb-2"
          name="screenRenderSettings.frequency"
          value={values?.screenRenderSettings?.frequency}
          type="number"
          min={5}
          step={1}
        />

        <div className="w-100">
          <div className={classNames('row', styles.iconFieldwrapper)}>
            <div className="d-flex col-4">
              <span>
                Чергувати з зображеннями <br /> (пропорція 4:3):
              </span>
            </div>
            <div className={classNames('col5', styles.wrapper)}>
              <Checkbox
                label=""
                name="screenRenderSettings.isShowCustomScreens"
                onChange={onChange}
                className={styles.chechbox}
              />
              <div className={classNames('p-02 ml-1', styles.iconButton)}>
                <ImageIcon onClick={openZoom} />
              </div>
              <label htmlFor="addCustomScreens" className={classNames('p-02 ml-1', styles.iconButton)}>
                <input
                  id="addCustomScreens"
                  className="d-none"
                  type="file"
                  accept="image/png, image/jpeg"
                  multiple
                  onChange={filesHandler('custom')}
                />
                <ImageEditIcon />
              </label>
            </div>
          </div>
        </div>
        <div className="w-100">
          <div className={classNames('row', styles.iconFieldwrapper)}>
            <div className="d-flex align-itmes-center col-4">
              <span>
                Логотип компанії при відсутності рейсів <br /> (пропорція 4:3):
              </span>
            </div>
            <div className={classNames('col5', styles.wrapper)}>
              <div className={styles.wrapper}>
                <Checkbox
                  label=""
                  name="screenRenderSettings.isShowLogo"
                  onChange={onChange}
                  className={styles.chechbox}
                />
                <div className={classNames('p-02 ml-1', styles.iconButton)}>
                  <ImageIcon onClick={openZoomLogo} />
                </div>
                <label htmlFor="addLogo" className={classNames('p-02 ml-1', styles.iconButton)}>
                  <input
                    id="addLogo"
                    className="d-none"
                    type="file"
                    accept="image/png, image/jpeg"
                    onChange={filesHandler('logo')}
                  />
                  <ImageEditIcon />
                </label>
                <div className={styles.timeTracker}>
                  <div className="d-flex align-items-center flex-row">
                    <h5 className="mr-2">з:</h5>
                    <Picker
                      name="screenRenderSettings.logoStartTime"
                      value={values?.screenRenderSettings?.logoStartTime}
                    />
                  </div>
                  <div className="d-flex align-items-center flex-row">
                    <h5 className="mr-2">по:</h5>
                    <Picker name="screenRenderSettings.logoEndTime" value={values?.screenRenderSettings?.logoEndTime} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {customImages.length > 0 && isShowZoom && (
        <ModalWrapper
          contentClassName={styles.modal}
          show
          onHide={closeZoom}
          size="lg"
          headerBtn={
            <div>
              <TopBorderBtn icon="delete" className="mt-2" clickHandler={openDeleteCustom} />
            </div>
          }
        >
          <div className="d-flex align-items-center flex-column h-100">
            {/* @ts-ignore */}
            <canvas ref={canvasRef} id="canvas" className={styles.crop} />
            <CarouselTv images={customImages} index={currentImage} setIndex={setCurrentImage} />
          </div>
        </ModalWrapper>
      )}
      {(values?.screenRenderSettings?.imageUrl || values?.screenRenderSettings?.imageFile) && isShowZoomLogo && (
        <ModalWrapper
          contentClassName={styles.modal}
          show
          onHide={closeZoomLogo}
          size="lg"
          headerBtn={
            <div>
              <TopBorderBtn icon="delete" className="mt-2" clickHandler={openDeleteLogo} />
            </div>
          }
        >
          <div className="d-flex align-items-center flex-column h-100">
            {/* @ts-ignore */}
            <canvas ref={canvasRef} id="canvas" className={styles.crop} />
            <CarouselTv
              images={[
                { imageUrl: values.screenRenderSettings.imageUrl, imageFile: values.screenRenderSettings.imageFile },
              ]}
            />
          </div>
        </ModalWrapper>
      )}

      <YesNoModal
        isShow={isShowDeleteCustom}
        title="Видалити зображення"
        closeModal={closeDeleteCustom}
        acceptHandler={deleteCustomHandler}
      />
      <YesNoModal
        isShow={isShowDeleteLogo}
        title="Видалити зображення"
        closeModal={closeDeleteLogo}
        acceptHandler={deleteLogoHandler}
      />
    </div>
  );
};

export default TvPanel;
